import { Route, Routes } from 'react-router-dom'
import { I18nProvider } from './i18n/I18nProvider'
import { ForgeProvider } from './data/ForgeProvider'
import Home from './pages/Home'
import Catalog from './pages/Catalog'
import Workflows from './pages/Workflows'
import WorkflowDetail from './pages/WorkflowDetail'
import Gallery from './pages/Gallery'

export default function App() {
  return (
    <I18nProvider>
      <ForgeProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/workflows" element={<Workflows />} />
          <Route path="/workflows/:id" element={<WorkflowDetail />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </ForgeProvider>
    </I18nProvider>
  )
}
